import React from "react";
import { TextInput, NumberInput } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { useFormState, useForm } from "react-final-form";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  input: {
    "& *": {
      marginRight: theme.spacing(2)
    }
  }
}));

const FormTab = (props) => {
  const { values } = useFormState();
  const form = useForm();
  const s = (fieldName) => `players.${props.index}.baseball.${fieldName}`;
  const classes = useStyles();
  const inningsPerGame = 7; // high-school soft/base-ball have 7 innings

  function hitsChanged(e) {
    const hits = Number(e.target.value);
    const atBats = _.get(values, s("atBats"));
    const battingAverage = atBats ? hits / atBats : 0;
    form.change(s("battingAverage"), battingAverage);
  }

  function atBatsChanged(e) {
    const hits = +_.get(values, s("hits"));
    const atBats = +e.target.value;
    const battingAverage = atBats ? hits / atBats : 0;
    form.change(s("battingAverage"), battingAverage);
  }

  function parseInningsPitched(innings) {
    //return [whole,outs] where outs can be undefined, return undefined if error
    const inningsString = "" + innings;
    const wholeInnings = inningsString.split(".")[0];
    const partialInnings = inningsString.split(".")[1];
    if (
      partialInnings === undefined ||
      partialInnings === "1" ||
      partialInnings === "2"
    )
      return [+wholeInnings, partialInnings];
    return undefined;
  }

  function convertInningsPitched(innings) {
    // innings-pitched is represented as a string "innings.outs" which looks
    // confusingly like a decimal. eg: 7.1 means 7 innings + 1 out, 7.2 means
    // 7 innings + 2 outs and just plain 7 means exactly 7 innings. other
    // values (eg:7.4) are illegal. again: this isn't a number!
    const inningsArray = parseInningsPitched(innings);
    if (!inningsArray) return undefined;
    const [whole, outs] = inningsArray;
    if (outs === "1") return whole + 1 / 3;
    if (outs === "2") return whole + 2 / 3;
    if (outs === undefined) return whole;
    return undefined;
  }

  function validateInningsPitched(innings) {
    // innings-pitched should always parse as a float.
    if (isNaN(+innings)) return "bad format";
    const inningsArray = parseInningsPitched(innings);
    if (inningsArray === undefined) return "bad outs";
    return undefined;
  }

  function inningsPitchedChanged(e) {
    const inningsPitched = convertInningsPitched(+e.target.value);
    const earnedRuns = +_.get(values, s("earnedRuns"));
    const earnedRunAverage = inningsPitched
      ? inningsPerGame * (earnedRuns / inningsPitched)
      : 0;
    form.change(s("earnedRunAverage"), earnedRunAverage);
  }

  function earnedRunsChanged(e) {
    const inningsPitched = convertInningsPitched(
      +_.get(values, s("inningsPitched"))
    );
    const earnedRuns = +e.target.value;
    const earnedRunAverage = inningsPitched
      ? inningsPerGame * (earnedRuns / inningsPitched)
      : 0;
    form.change(s("earnedRunAverage"), earnedRunAverage);
  }

  return (
    <>
      <NumberInput label="Player Game Count" source={s("playerGameCount")} />
      <div className={classes.input}>
        <h3>Hitting</h3>
        <NumberInput label="Hits" source={s("hits")} onChange={hitsChanged} />
        <NumberInput
          label="At Bats"
          source={s("atBats")}
          onChange={atBatsChanged}
        />
        <NumberInput label="Runs" source={s("runs")} />
        <NumberInput label="Doubles" source={s("doubles")} />
        <NumberInput label="Triples" source={s("triples")} />
        <NumberInput label="Home Runs" source={s("homeRuns")} />
        <NumberInput label="RBIs" source={s("runsBattedIn")} />
        <NumberInput label="Stolen Bases" source={s("stolenBases")} />
        <NumberInput label="Batting Average" source={s("battingAverage")} />
      </div>
      <div className={classes.input}>
        <h3>Pitching</h3>
        <TextInput
          label="Innings Pitched"
          source={s("inningsPitched")}
          onChange={inningsPitchedChanged}
          validate={validateInningsPitched}
        />
        <NumberInput label="Runs Allowed" source={s("runsAllowed")} />
        <NumberInput
          label="Earned Runs"
          source={s("earnedRuns")}
          onChange={earnedRunsChanged}
        />
        <NumberInput label="Hits Allowed" source={s("hitsAllowed")} />
        <NumberInput label="Walks" source={s("basesOnBalls")} />
        <NumberInput label="Strikeouts" source={s("strikeouts")} />
        <NumberInput label="Pitching Wins" source={s("pitchingWins")} />
        <NumberInput label="Pitching Losses" source={s("pitchingLosses")} />
        <NumberInput label="Saves" source={s("saves")} />
        <NumberInput label="ERA" source={s("earnedRunAverage")} />
      </div>
    </>
  );
};

export default FormTab;
